<template>
  <GestionEventosUsuario />
</template>
<script>
import GestionEventosUsuario from "./components/GestionEventosUsuario.vue";
export default {
  name: "EventosUsuario",
  components: { GestionEventosUsuario }
};
</script>